import { PlannedWork } from '../../../../Sections/properties';
import { getEnumObjectDiffOptionRows, getEnumObjectIdenticalOptionRows } from '../../optionRowData';

/**
 * Returns all identical options
 *
 * @param planValue
 * @param liveValue
 * @return {{key: string, left: *, right: *}[]}
 */
export const getIdenticalPlannedWorkOptionRows = (planValue, liveValue) => {
    return getEnumObjectIdenticalOptionRows(PlannedWork, planValue, liveValue);
};

/**
 * Returns all options which are
 *
 * @param planValue
 * @param liveValue
 * @return {{key: string, left: *, right: *}[]}
 */
export const getDiffPlannedWorkOptionRows = (planValue, liveValue) => {
    return getEnumObjectDiffOptionRows(PlannedWork, planValue, liveValue);
};
